module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/4858dadd92c9d7d193a780c3679d6355.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend4.svg
// module id = AqsK
// module chunks = 1